import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { X } from 'react-feather';
import { Button, Input, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { assignRetailerToCompany, UnassignRetailerToCompany } from '../ReduxToolkit/Reducers/retailers';
import { assignWholesalerToCompany, UnassignWholesalerToCompany } from '../ReduxToolkit/Reducers/wholesaler';
import { assignBrandToCompany, UnassignBrandToCompany } from '../ReduxToolkit/Reducers/brands';
import { toast } from 'react-toastify';

function CompaniesDrawer({ isOpen, type, entity, onClose, onSuccess }) {
  const dispatch = useDispatch();
  const companies = useSelector(state => state.brands?.companies);
  const [company, setCompany] = useState(entity?.company || []);

  useEffect(() => {
    if (isOpen) setCompany(entity?.company)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const onRemove = async (id) => {
    const filteredData = company.filter(c => c.id !== id);
    setCompany(filteredData);

    if (type === 'brand') {
      await dispatch(UnassignBrandToCompany({ brand_id: entity.id, company_id: id }));
    }
    if (type === 'retailer') {
      await dispatch(UnassignRetailerToCompany({ retailer_id: entity.id, company_id: id }));
    }
    if (type === 'wholesaler') {
      await dispatch(UnassignWholesalerToCompany({ wholesaler_id: entity.id, company_id: id }));
    }

    if (onSuccess) onSuccess(true);
  }

  const onAdd = async (e) => {
    const selectedCompanyId = Number(e.target.value);

    if (company?.find((c) => c?.id === selectedCompanyId)) {
      return toast.info('Already Added !');
    }

    const selectedCompany = companies?.find((c) => c?.id === selectedCompanyId);

    setCompany((prev) => ([...prev, selectedCompany]));
    if (type === 'brand') {
      await dispatch(assignBrandToCompany({ brands: [{ id: entity?.id }], company_id: selectedCompanyId }))
    }
    if (type === 'retailer') {
      await dispatch(assignRetailerToCompany({ retailers: [{ id: entity?.id }], company_id: selectedCompanyId }))
    }
    if (type === 'wholesaler') {
      await dispatch(assignWholesalerToCompany({ wholesaler: [{ id: entity?.id }], company_id: selectedCompanyId }))
    }

    if (onSuccess) onSuccess(true);
  };

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      direction='right'
      className='p-3 w-25'
    // enableOverlay={false}
    >
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <h3>{entity?.name}</h3>
        <button className='btn' onClick={onClose}><X /></button>
      </div>
      <h5 className='border-bottom pt-4 pb-2' style={{ fontWeight: 'bold' }}>Companies</h5>

      {company?.length ? company?.map((c, index) => (
        <div key={c?.id} className='d-flex justify-content-between align-items-center gap-2 border-bottom py-3 px-2'>
          <h6>{index + 1}) {c?.name}</h6>
          <Button close className='btn' onClick={() => onRemove(c?.id)} />
        </div>
      )) : <h6 className='my-5'>No Companies Assigned Yet</h6>}

      <div className='my-3'>
        <Label for='add'>Add Company</Label>
        <Input id='add' type='select' placeholder='Add Company' className='w-50' onChange={onAdd}>
          <option>Select</option>
          {companies?.map((company) => (
            <option key={company?.id} value={company?.id}>{company?.name}</option>
          ))}
        </Input>
      </div>
    </Drawer>
  )
}

export default CompaniesDrawer;
